module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAY1BMVEUAAAAt1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t1VrJZqAAAAIHRSTlMABOy4Jhn58ePd0a2ePRUOC81+eFosyb2zmJSQX1VDL49yZuQAAACHSURBVCjPzY5HEsIwDEVlyy1x4nR6+fc/JTOBjAxhWMCGt5KeKv2COhzVO9/ugNiuve3gPTbp1U8BYboGFObZXzw6S2RL6Dr3Jwee1zcMN4rvgb16vFYBPUk8SNcAVGqe3sKdKWN04EbuZdQapaWolw8FU+hIhhOtSHxvBhYj2T8Ucj4VvuIGLMkNRU+STEUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zy-hover.png
// module id = 454
// module chunks = 0 1 2 3 4 5 6 7